import { NgModule } from '@angular/core';
import { Routes, RouterModule , PreloadAllModules} from '@angular/router';
import { BookingComponent } from './pages/common/customer/booking/booking.component';
import { SuccessPaymentComponent } from './pages/common/success-payment/success-payment.component';
import { SocialMediaLinkComponent } from './pages/common/social-media-link/social-media-link.component';
import { LoginComponent } from './pages/common/auth/login/login.component';
import { RegisterComponent } from './pages/common/auth/register/register.component';
import { PagesCoreComponent } from './pages/pages-core/pages-core.component';
import { DashboardComponent } from "./pages/components/dashboard/DashboardComponent";
import { BookingManagementComponent } from './pages/components/booking-management/booking-management.component';
import { WorkingDaysTimeComponent } from './pages/components/working-days-time/working-days-time.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/customer/acount',
    pathMatch: 'full',
},
{
  path: '',
  component: PagesCoreComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'admin/dashboard'
    },
    {
      path: 'admin/dashboard',
     component: DashboardComponent,
    },
    {
      path: 'admin/Booking',
     component: BookingManagementComponent,
    },
    {
      path: 'admin/WorkingTime',
     component: WorkingDaysTimeComponent,
    },

  ]
},
{
  path: 'auth/login',
 component: LoginComponent,
},
  {
    path: 'customer/booking',
   component: BookingComponent,
   pathMatch: 'full',
  },
  {
    path: 'customer/acount',
   component: SocialMediaLinkComponent,
   pathMatch: 'full',
  },
  {
    path: 'success',
   component: SuccessPaymentComponent,
   pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    useHash: false,
    scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
